/** API/Mongo may return non-strings on older incident rows; never call .trim() blindly. */
export function asText(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function hasText(value: unknown): boolean {
  return asText(value).trim().length > 0;
}
